import React from "react";
import _ from "lodash";
import {Box} from "@mui/system";
import {msgSource} from "_constants";
import organizationStyles from "../../organizationMainStyles";
import CustomFieldSetting from "./CustomFieldUtils/CustomFieldSetting";
import MsgDataSourceTrendsToggles from "./MsgDataSourceTrendsToggles";

const SOURCES_WITH_CUSTOM_FIELDS = [msgSource.ZENDESK, msgSource.GORGIAS];

export default function MsgDataSourceDetails({msgSourceProp, trendsMsgDataSourcesById, mode, label}) {
    const msgSourceName = _.toString(msgSourceProp?.name).toLowerCase();
    const msgDataSources = msgSourceProp?.msgDataSources || [];
    const hasCustomFields = SOURCES_WITH_CUSTOM_FIELDS.includes(msgSourceName);

    return (
        <>
            {msgDataSources.map((msgDataSource, index) => {
                const trendsMsgDataSource = msgDataSource?.trendsId != null
                    ? _.get(trendsMsgDataSourcesById, msgDataSource.trendsId)
                    : null;
                return (
                    <Box key={msgDataSource?.id ?? index} sx={organizationStyles.heading}>
                        <Box sx={styles.detailsContainer}>
                            <Box sx={styles.settingHeader}>
                                {msgDataSource?.name}
                            </Box>
                            {trendsMsgDataSource && (
                                <Box sx={styles.settingContainer}>
                                    <MsgDataSourceTrendsToggles
                                        msgSourceName={msgSourceName}
                                        trendsMsgDataSource={trendsMsgDataSource}
                                        label={label}
                                    />
                                </Box>
                            )}
                            {hasCustomFields && (
                                <Box sx={styles.settingContainer}>
                                    <CustomFieldSetting
                                        msgDataSource={msgDataSource}
                                        mode={mode}
                                    />
                                </Box>
                            )}
                        </Box>
                    </Box>
                );
            })}
        </>
    );
}

const styles = {
    detailsContainer: {
        border: '1px solid #b6bebf',
        borderRadius: '10px',
        overflow: 'hidden',
        mb: '16px',
    },
    settingContainer: {
        p: '15px',
        '&:not(:last-of-type)': {
            borderBottom: '1px solid #b6bebf',
        },
    },
    settingHeader: {
        borderBottom: '1px solid #b6bebf',
        p: '15px',
    },
};
